import { useCallback } from 'react';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import {
  PRESCRIBER,
} from '../../constants/patientChart.constant';
import { SearchOrdersControllerHOC } from '../../controllers/searchOrders';
import {
  NavBar, NavKey, enabledNavItems,
  InfoCard, PageTitle,
} from '../../components/patientChart';
import { PageHeading, useAvatarTitle } from '../../components/PageHeading';
import { SearchFormV2 as SearchForm, SearchResult } from '../../components/searchOrders';
import useNavItems from '../../hooks/useNavItems';
import useVisits from '../../hooks/useVisits';
import { FEATURE } from '../../utils/feature';
import Logo from '../../assets/logo.png';
import '../patientChart/styles.css';
import { SEARCH, SEARCHED_ORDER } from '../../constants/searchOrders.constant';

const hasFeature = FEATURE();

const SelectedNavItem = {
  key: NavKey.so
};
export const NavItems = enabledNavItems([
  NavKey.sv,
  NavKey.ao,
  NavKey.tasks,
  NavKey.pcm,
  NavKey.so,
]);

const BottomNavItems = enabledNavItems([
  NavKey.v1,
]);

export const SearchOrders = ({
  history,
  location,
  searchData: searches = [SEARCHED_ORDER()],
  searchOrdersAPI = {},
  headerInfoAPI = {},
  selectedPrescriberInfo: prescriber = PRESCRIBER(),
  scheduledVisits = {},
  asyncOrders = {},
  tasksInfo = {},

  GetHeaderInfo: getPrescriber = async () => {},
  SearchData: searchOrders = async (body = SEARCH()) => ({}),
  GetScheduleVisitsLV: getScheduledVisits = async () => {},
  GetPendingFilesLV: getPendingVisits = async () => {},
  GetTasks: getTasks = async () => {},
  LogOff: logOff = async () => ({}),
}) => {
  const { navItems, bottomNavItems } = useNavItems({
    scheduledVisits: scheduledVisits?.visits?.data || [],
    asyncOrders: asyncOrders?.visits?.data || [],
    tasks: tasksInfo?.data || [],
    items: NavItems,
    bottomItems: BottomNavItems,
    history,
  });

  const { avatarTitle } = useAvatarTitle(prescriber);

  useVisits({
    prescriber,
    scheduledVisits,
    asyncOrders,
    headerInfoAPI,
    tasksInfo,
    getTasks,
    getPrescriber,
    getPendingVisits,
    getScheduledVisits,
  });

  const handleRoute = useCallback((url = '') => {
    history.push(url);
  }, [history]);

  const PageHeadingComponent = new Map([
    [true, (
      <PageHeading
        logo={Logo}
        message={prescriber.Message}
        avatarTitle={avatarTitle}
        hasActions
        logOff={logOff}
        handler={{
          route: handleRoute,
        }}
      />
    )],
    [false, <></>]
  ]);

  const NavBarComponent = new Map([
    [true, <NavBar items={navItems} bottomItems={bottomNavItems} selectedItem={SelectedNavItem} />],
    [false, <></>]
  ]);

  return (
    <div className='patient-chart-container flex flex-column flex-fill'>
      {PageHeadingComponent.get(hasFeature.PAGE_HEADING)}

      <div className='patient-chart-content flex'>
        {NavBarComponent.get(hasFeature.NAV_BAR)}

        <div className='flex flex-column flex-fill gap-24'>
          <PageTitle title="Search Orders" type={2} hideRefresh />

          <div className='flex flex-fill justify-content-space-between gap-24 p-l-6 p-r-6'>
            <SearchResult
              history={history}
              location={location}
              searches={searches}
              searchOrdersAPI={searchOrdersAPI}
            />

            <div className='min-width-380 max-width-420'>
              <InfoCard
                heading={
                  <div className='flex align-items-center justify-content-space-between flex-fill'>
                    <div>{'Search Options'}</div>
                    <SearchRoundedIcon fontSize='medium' />
                  </div>
                }
                content={
                  <SearchForm
                    heading='Search Options'
                    searchOrders={searchOrders}
                    searchOrdersAPI={searchOrdersAPI}
                  />
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchOrdersControllerHOC(SearchOrders);
